export default {
  album: '/image-album',
  gallery: '/image-gallery',
}
